import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState('AuthModule', { _$mustCloseCashDesk: 'mustCloseCashdesk' }),
    },
    methods: {
        ...mapActions('AuthModule', {
            _$fetchMustCloseCashDesk: 'fetchMustCloseCashDesk',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        _$closeCashdeskWarning() {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Cierre de Caja',
                    body:
                        'Existe una apertura de caja de días anteriores que debe ser cerrada',
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        //TODO: Implement Globally
        _$checkMustCloseStatus() {
            return new Promise((resolve, reject) => {
                if (this._$mustCloseCashdesk === false) {
                    return resolve(false)
                }
                if (
                    [null, undefined, true].includes(
                        this._$mustCloseCashDesk
                    ) ||
                    ![true, false].includes(this._$mustCloseCashDesk)
                ) {
                    this._$fetchMustCloseCashDesk()
                        .then(r => {
                            if (r) this._$closeCashdeskWarning()
                            resolve(r)
                        })
                        .catch(reject)
                }
            })
        },
    },
    beforeRouteLeave(to, from, next) {
        if (
            [
                'rendicion',
                'reports',
                'salir',
                'transbank',
                'reimprimir',
                'closeCash',
            ].includes(to.name)
        )
            return next()
        this._$checkMustCloseStatus()
            .then(r => {
              if (r) return next('/close')
                return next()
            })
            .catch(() => next(false))
    },
}
